
export default {
  state: {
    area_name: null,
  },

  mutations: {
    ["AREA_NAME"](state, data) {
      state.area_name = data;
    },
  },

  actions: {
    updateAreaName({ commit }, name) {
      commit("AREA_NAME", name);
    },
  },

  getters: {
    getAreaName(state) {
      return state.area_name;
    },
  },
};
